<template>
    <div>
        <div class="sensor-title primary--text">
            {{ label }}
        </div>

        <div class="lm-border pa-2" style="height: 250px;">
            <div class="sensor-eid">
                {{ sensor && sensor.eid ? sensor.eid : "---" }}
            </div>

            <c-inspection-image
                v-if="sensor.image"
                style="width: 200px; height: 200px; margin-left: auto; margin-right: auto; margin-bottom: 8px;"
                :inspection-id = "inspection.id"
                :image-id      = "sensor.image"
            />
        </div>
    </div>
</template>

<script>
import CInspectionImage from "@/modules/dis/components/inspection/common/components/CInspectionImage.vue";

export default {
    name: "PLgSmartSensor",
    components: {
        CInspectionImage
    },

    props: {
        inspection: {

        },

        label: {

        },

        sensor: {

        }
    }
}
</script>

<style scoped>

.sensor-title {
    font-size: 16px!important;
    font-weight: 500!important;
    text-align: center;
    margin-bottom: 4px;
}

.sensor-eid {
    text-align: center;
    font-size: 14px;
    margin-bottom: 4px;
}

</style>